<template>
    <v-camera-device ref="camera"/>
</template>

<script>
    import vCameraDevice from '@/components/v-camera-device';

    export default {
        components: {vCameraDevice},
        name: 'camera-form-step',
        inject: ['registerAction', 'stepKey'],
        props: {
            attributeName: {
                type: String,
                required: true,
            },
        },
        methods: {
            submit() {
                const imageCapture = this.$refs.camera.submit();
                if (!imageCapture) {
                    return false;
                }
                return {
                    type: 'camera',
                    object: imageCapture,
                };
            },
            register() {
                const action = {
                    attributeName: this.attributeName,
                    delegated: this.submit,
                };
                this.registerAction(this.stepKey, action);
            },
        },
        mounted() {
            this.register();
        },
    };
</script>
